module.exports = __webpack_public_path__ + "assets/img/weapp.184bfd1a.jpg";